<template>
  <div class="ma-0 pa-4 px-16 fill-height full-width main_container">
    <v-overlay :value="loading">
        <v-progress-circular color="#00C1B6" indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <div class="mb-4 mt-10 d-flex justify-space-between align-end">
<!-- TITULO      -->
      <span class="titulo mx-0">
        Mercado de destino
      </span>
<!-- NOVO MERCADO DESTINO      -->
      <v-btn class="white--text" color="#00C1B6" to="/detalheMercadoDestino">Cadastrar Novo</v-btn>
    </div>
    <v-row dense class="my-4 mx-0 d-flex justify-space-between align-end">
<!-- BUSCAR      -->
      <v-text-field color="white" solo hide-details placeholder="Busque por mercados de destino" clearable
                    v-model="filtroBusca" @click:clear="limparBusca" @keydown.enter="loadListaMercadoDestino" >
        <template v-slot:append>
            <v-btn color="#799596" :loading="loading" text @click="loadListaMercadoDestino">BUSCAR</v-btn>
        </template>
      </v-text-field>
    </v-row>
<!-- GRID MERCADOS      -->
    <div class="pa-0 mt-4 d-flex flex-column align-stretch" v-if="listaMercadoDestino.length > 0" >
      <v-row class="mb-0">
        <v-col xl="6" md="6" cols="12">
          <mercado-destino-card v-for="mercado in listaMercadoDestinoEsq"
                                         :key="'mercado_card_esq__' + mercado.idMercadoDestino"
                                         :mercado="listaMercadoDestino[mercado.id]"
                                         @deletarMercado="deletarMercado(mercado.id)"
          />
        </v-col>
        <v-col xl="6" md="6" cols="12">
          <mercado-destino-card v-for="mercado in listaMercadoDestinoDir"
                                         :key="'mercado_card_dir__' + mercado.idMercadoDestino"
                                         :mercado="listaMercadoDestino[mercado.id]"
                                         @deletarMercado="deletarMercado(mercado.id)"
          />
        </v-col>
      </v-row>
      <v-row dense class="mb-16 d-flex justify-center align-end">
        <v-pagination class="pb-0" color="#00C1B6" v-model="page" :length="totalPages" :total-visible="7" />
      </v-row>
    </div>
<!-- ESTADO VAZIO      -->
    <v-container fluid class="pa-0 mt-8 d-flex align-start fill-height" v-else-if="!loading" >
      <alert-sem-dados-para-etapa
          :titulo="`Não há mercado destino cadastrado ${!mensagemBusca ? '' : 'com o nome de ' + mensagemBusca}`"
                                  sub-titulo="Cadastre no botão CADASTRAR NOVO"></alert-sem-dados-para-etapa>
    </v-container>

  </div>
</template>

<script>
import AlertSemDadosParaEtapa from "../components/AlertSemDadosParaEtapa";
import MercadoDestinoCard from "../components/mercadoDestino/MercadoDestinoCard";
import {MODELS} from "../resources";

export default {
  name: "MercadoDestino",
  components: {AlertSemDadosParaEtapa, MercadoDestinoCard},
  data: () =>({
    loading: false,
    filtroBusca: '',
    mensagemBusca: '',
		totalPages: 1,
		page: 1,
    listaMercadoDestino: [],
  }),
  computed: {
    listaMercadoDestinoEsq() {
      return this.listaMercadoDestino.filter(
                (_, idx) => idx % 2 === 0)
    },
    listaMercadoDestinoDir() {
      return this.listaMercadoDestino.filter(
                (_, idx) => idx % 2 !== 0)
    },
  },
  methods: {
    deletarMercado(idx) {
      this.listaMercadoDestino.splice(idx, 1)
      this.listaMercadoDestino = this.listaMercadoDestino.map((mercado, idx) => _.extend(mercado, {id: idx}))
    },
    limparBusca() {
      this.filtroBusca = null
      this.loadListaMercadoDestino()
    },
    loadListaMercadoDestino(){
      this.loading = true
      this.mensagemBusca = this.filtroBusca

      let query = new URLSearchParams()

      let cfNmProdutor = {"field": "dsMercadoDestino", "op": "ilike", "value": `%${this.filtroBusca}%`}
      if(this.filtroBusca && this.filtroBusca !== '')
        query.append("cf", JSON.stringify(cfNmProdutor))

      query.append("per_page", '8')
      query.append("page", this.page)

      this.$axios.get(`mercado-destino/`, {params: query })
          .then(res => {
            if (!res.data) return
            if (!res.data[0].data) {
              this.listaMercadoDestino = []
              this.totalPages = 1
              return
            }

            this.totalPages = res.data[0].meta.pages
            this.listaMercadoDestino = res.data[0].data.map((mercado, idx) => _.extend(mercado, {id: idx}))
          })
          .catch(error => {
            this.$store.commit("setSnack", {type: "error", msg: error})
            this.loading = false
          })
          .finally(() => this.loading = false)
    },
  },
  watch: {
    page() {
      this.loadListaMercadoDestino()
    }
  },
  mounted() {
    this.loadListaMercadoDestino()
  },
}
</script>

<style scoped>
.main_container {
  background-color: #f2f5f3;
  border-radius: 0 0 8px 8px;
}

.titulo {
  font: normal normal normal 32px/37px Roboto;
  color: #37565C;
  opacity: 0.8;
}

</style>